module.exports = __webpack_public_path__ + "static/img/custom-filter-no-data.c51a947.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/components/query-table/assets/custom-filter-no-data.png
// module id = 2k7P
// module chunks = 6